:host {
  font-family: var(--ai12z-bot-font-family) !important;
  font-size: var(--ai12z-bot-font-size) !important;
}
.welcome-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--ai12z-bot-welcome-bgcolor);
  text-align: center;
  padding: 20px;
}

.welcome-screen p {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.button-container button {
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  background-color: var(--ai12z-bot-primary-bgcolor);
  color: var(--ai12z-bot-primary-color);
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.button-container button:hover {
  background-color: var(--ai12z-bot-hover-button-color);
}
